<template>
    <nomad-lk-notifications
        v-if="isWebComponentReady"
        ref="notificationsRef"
    >
    </nomad-lk-notifications>
</template>

<script>
import {mapActions, mapMutations} from "vuex";
import Cookies from "js-cookie";
import { getEnvironmentByOrigin } from '@/utils/getEnvironment'
import {OLD_TOKEN, WEB_MODULES_TOKEN} from "@/consts/newChat";

export default {
    data() {
        return {
            isWebComponentReady: false,
            elementsClassesToHideList: [
                'header-lk',
                'grecaptcha-badge',
                'ws-chat',
                'tab-content',
                'fixed-mob-button',
            ],
            elementsClassesToFixPositionList: [
                'ws-chat',
            ],
        };
    },
    computed: {
        isNewNotificationsOpen() {
            return this.$store.state.newNotifications.isNewNotificationsOpen;
        },
        locale() {
            return this.$i18n.locale
        },
        user() {
            return this.$store.state.auth.user
        },
        token() {
            return this.$store.state.auth.webModulesToken;
        }
    },
    watch: {
        isNewNotificationsOpen: {
            immediate: true,
            handler (newVal) {
                newVal ? this.openNotifyModal() : this.closeNotifyModal
            }
        },
        locale: {
            immediate: true,
            handler (newVal) {
                this.$refs.notificationsRef?.setAttribute("locale", newVal.toLowerCase());
            }
        },
        token: {
            immediate: true,
            handler (newVal) {
               this.updateToken(newVal)
            }
        }
    },
    methods: {
        ...mapActions("newNotifications", ["closeNewNotificationsModal"]),
        ...mapMutations("newNotifications", ["SET_UNREAD_NOTIFICATIONS_COUNT"]),
        ...mapMutations("auth", ["SET_WEB_MODULES_TOKEN"]),
        openNotifyModal() {
              this.setToken()
              this.$refs.notificationsRef?.setAttribute("is-open", 'open');
              this.updateLocale()
              this.$refs.notificationsRef?.addEventListener("notifications-close", this.closeNotifyModal);
              this.hideNonChatElements();
            },
        setEnvironment() {
/*
            const currentEnvironment = process.env.NODE_ENV ?? 'production';
*/ // TODO необходимо понять, почему при билде deploy_dev скриптом у них идет building for production, и убрать заплатку ниже

            this.$refs.notificationsRef?.setAttribute("environment", getEnvironmentByOrigin());
        },
        closeNotifyModal() {
            this.$refs.notificationsRef?.setAttribute("is-open", '');
            this.$refs.notificationsRef?.removeEventListener("notifications-close", this.closeNotifyModal)
            this.closeNewNotificationsModal();
            this.showNonChatElements();
        },
        hideNonChatElements() {
            document.documentElement.classList.add('hide-elements-under-new-chat')
        },
        showNonChatElements() {
            document.documentElement.classList.remove('hide-elements-under-new-chat')
        },
        updateLocale() {
            this.$refs.notificationsRef?.setAttribute("locale", this.$i18n.locale)
        },
        setToken() {
            const token = Cookies.get(WEB_MODULES_TOKEN) ?? Cookies.get(OLD_TOKEN)
            this.$refs.notificationsRef?.setAttribute("token", token ?? '')
            this.SET_WEB_MODULES_TOKEN(token ?? '')
        },
        updateUnreadCounter(event) {
            this.SET_UNREAD_NOTIFICATIONS_COUNT(Number(event.detail) ?? 0)
        },
        updateToken(event) {
            this.$refs.notificationsRef?.setAttribute("token", event ?? '')
        },
        onRefreshToken(event) {
            Cookies.set(WEB_MODULES_TOKEN, event.detail, {expires: 365})
            this.SET_WEB_MODULES_TOKEN(event.detail)
        },
      },
    mounted() {
        this.isWebComponentReady = true;
        this.$nextTick(() => {
            this.setEnvironment()
            this.setToken()
            this.$refs.notificationsRef?.addEventListener("update-unread", this.updateUnreadCounter);
            this.$refs.notificationsRef?.addEventListener("update-token", this.onRefreshToken);
        })
    },
    beforeDestroy() {
        this.$refs.notificationsRef?.removeEventListener("update-unread", this.updateUnreadCounter);
        this.$refs.notificationsRef?.removeEventListener("notifications-close", this.closeNotifyModal);
        this.$refs.notificationsRef?.removeEventListener("update-token", this.onRefreshToken);
    }
};
</script>
